import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.time || initialState;

const makeSelectTimeFilterMenuStatus = () =>
  createSelector(selectGlobal, (timeState) => timeState.timeFilterMenuStatus);

export { makeSelectTimeFilterMenuStatus };
